// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle--toggle--1G1qC","on":"Toggle--on--3sxGf","disabled":"Toggle--disabled--2A30e"};